import React, { useEffect, useRef } from "react";
import { useGlobalData } from "@/lib/dataStreams";
import { Terminal } from "@phosphor-icons/react";

const colorMap = {
  muted: "text-slate-500",
  green: "text-emerald-400",
  cyan: "text-indigo-400",
  red: "text-rose-400",
};

export default function LiveBotTerminal({ maxItems = 20 }) {
  const { botLogs } = useGlobalData();
  const entries = botLogs.slice(-maxItems);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [entries]);

  return (
    <div className="bg-slate-900/50 backdrop-blur-md border border-slate-800 rounded-2xl p-6 relative h-full flex flex-col shadow-inner" data-testid="hero-terminal">
      <div className="flex items-center justify-between mb-6 border-b border-slate-800 pb-4 shrink-0">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-rose-500/20 flex items-center justify-center"><div className="w-1.5 h-1.5 rounded-full bg-rose-500" /></div>
          <div className="w-3 h-3 rounded-full bg-amber-500/20 flex items-center justify-center"><div className="w-1.5 h-1.5 rounded-full bg-amber-500" /></div>
          <div className="w-3 h-3 rounded-full bg-emerald-500/20 flex items-center justify-center"><div className="w-1.5 h-1.5 rounded-full bg-emerald-500" /></div>
        </div>
        <div className="flex items-center gap-2 bg-slate-950 px-3 py-1 rounded-full border border-slate-800">
          <Terminal size={14} className="text-indigo-400" />
          <span className="text-slate-300 text-[10px] font-medium tracking-widest uppercase">system_log.exe</span>
          <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse ml-1" />
        </div>
      </div>

      <div
        ref={scrollRef}
        className="space-y-2.5 font-mono text-xs overflow-y-auto flex-1 custom-scrollbar pr-2 min-h-[260px]"
        data-testid="bot-feed-stream"
      >
        {entries.length === 0 ? (
          <div className="text-slate-500 animate-pulse flex items-center gap-2">
            <span className="text-indigo-400">❯</span> Establishing secure connection...
          </div>
        ) : (
          entries.map((e) => (
            <div
              key={e.idx}
              className={`flex items-start gap-3 ${colorMap[e.color] || colorMap.muted}`}
              style={{ animation: "fade-in 0.3s ease-out" }}
            >
              <span className="text-slate-600 shrink-0 select-none">[{e.ts}]</span>
              <span className="break-all">{e.text}</span>
            </div>
          ))
        )}
      </div>

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(99, 102, 241, 0.2);
          border-radius: 4px;
        }
      `}</style>
    </div>
  );
}
